function validateBookingDetails(bookDetails, minAge, showModal, remainingSeats) {
    for(let i=0;i<bookDetails.length;i++){
        if(bookDetails[i].firstName.trim() === '' || bookDetails[i].firstName === null){
            showModal("Please enter a valid First Name");
            return false;
        }
        if(bookDetails[i].firstName.length > 12){
            showModal("FIRST NAME LENGTH CANNOT BE GREATER THAN 12");
            return false;
        }

        if(bookDetails[i].lastName.trim() === '' || bookDetails[i].lastName === null){
            showModal("PLEASE ENTER A VALID LAST NAME");
            return false;
        }
        if(bookDetails[i].lastName.length > 12){
            showModal("LAST NAME LENGTH CANNOT BE GREATER THAN 12");
            return false;
        }

        if(bookDetails[i].mobileNumber.trim() === '' || bookDetails[i].mobileNumber === null){
            showModal("PLEASE ENTER A VALID MOBILE NUMBER");
            return false;
        }
        if(bookDetails[i].mobileNumber.length > 10){
            showModal("MOBILE NUMBER LENGTH CANNOT BE GREATER THAN 10");
            return false;
        }

        if(bookDetails[i].whatsAppNumber.trim() === '' || bookDetails[i].whatsAppNumber === null){
            showModal("PLEASE ENTER A VALID WHATSAPP NUMBER");
            return false;
        }
        if(bookDetails[i].whatsAppNumber.length > 10){
            showModal("WHATSAPP NUMBER LENGTH CANNOT BE GREATER THAN 10");
            return false;
        }

        if(bookDetails[i].email.trim() === '' || bookDetails[i].email === null){
            showModal("PLEASE ENTER A VALID EMAIL");
            return false;
        }

        if(bookDetails[i].age.trim() === '' || bookDetails[i].age === null){
            showModal("PLEASE ENTER A VALID AGE");
            return false;
        }

        if(bookDetails[i].age < minAge){
            showModal("AGE CANNOT BE LESS THAN " +  minAge);
            return false;
        }
    }
    if(bookDetails.length > remainingSeats){
        showModal("Sorry! We are just left with " + remainingSeats + " seat/s");
        return false;
    }
    return true;
}

function validateTrekDetails(trekName, totalSpots, numberOfDays, startDate, endDate, trekLocation, trekGmapLocation, trekPrice, expDate, pickUpLocation, pickUpGmapLocation, trekDescription, difficultyLevel, trekLength, altitude, minAge, bookDetails, notIncludedDetails, thingsToCarryDetails, base64ImageData, fileExtension, showModal){
    if(trekName.trim() === '' || trekName === null){
        showModal("Please enter a valid Trek Name");
        return false;
    }
    if(totalSpots.trim() === '' || totalSpots === null || totalSpots <= 0){
        showModal("Please enter a valid maximum trekkers");
        return false;
    }
    if(numberOfDays.trim() === '' || numberOfDays === null || numberOfDays <= 0){
        showModal("Please enter a valid number of days");
        return false;
    }
    if(trekLocation.trim() === '' || trekLocation === null ){
        showModal("Please enter a valid Trek Location");
        return false;
    }
    if(trekGmapLocation.trim() === '' || trekGmapLocation === null ){
        showModal("Please enter a valid Trek Location google map link");
        return false;
    }
    if(trekPrice.trim() === '' || trekPrice === null || trekPrice <= 0){
        showModal("Please enter a valid Trek Location Trek Price");
        return false;
    }
    if(pickUpLocation.trim() === '' || pickUpLocation === null ){
        showModal("Please enter a valid Pick Up Location");
        return false;
    }
    if(pickUpGmapLocation.trim() === '' || pickUpGmapLocation === null ){
        showModal("Please enter a valid pick up Location google map link");
        return false;
    }
    if(trekDescription.trim() === '' || trekDescription === null ){
        showModal("Please enter a valid Trek Description");
        return false;
    }
    if(difficultyLevel.trim() === '' || difficultyLevel === null ){
        showModal("Please enter a valid Difficulty Level");
        return false;
    }
    if(trekLength.trim() === '' || trekLength === null || trekLength <= 0){
        showModal("Please enter a valid Trek length");
        return false;
    }
    if(altitude.trim() === '' || altitude === null || altitude <= 0){
        showModal("Please enter a valid Trek length");
        return false;
    }
    if(minAge.trim() === '' || minAge === null || minAge <= 0){
        showModal("Please enter a valid Minimum Age");
        return false;
    }
    if(startDate.trim() === '' || startDate === null){
        showModal("Please enter a valid Start Date");
        return false;
    }
    if(endDate.trim() === '' || endDate === null){
        showModal("Please enter a valid End Date");
        return false;
    }
    if(expDate.trim() === '' || expDate === null){
        showModal("Please enter a valid End Date");
        return false;
    }
    if(new Date(startDate) > new Date(endDate)){
        showModal("Start Date is greater than end date");
        return false;
    }
    if(new Date(expDate) > new Date(startDate)){
        showModal("Expiry Date is greater than start date");
        return false;
    }
    if(new Date(expDate) > new Date(endDate)){
        showModal("Expiry Date is greater than end date");
        return false;
    }
    if(base64ImageData.trim() === '' || base64ImageData === null){
        showModal("Please enter a valid Trek Image");
        return false;
    }
    if (fileExtension !== 'jpg' && fileExtension !== 'png' && fileExtension !== 'jpeg') {
        showModal("Please upload an image with jpg, png, or jpeg format");
        return false;
    }
    for(let i=0;i<bookDetails.length;i++){
        if(bookDetails[i].includeRow.trim() === '' || bookDetails[i].includeRow === null){
            showModal("Please enter a valid details in What's Included row");
            return false;
        }
    }
    for(let i=0;i<notIncludedDetails.length;i++){
        if(notIncludedDetails[i].notIncludeRow.trim() === '' || notIncludedDetails[i].notIncludeRow === null){
            showModal("Please enter a valid details in What's not Included row");
            return false;
        }
    }
    for(let i=0;i<thingsToCarryDetails.length;i++){
        if(thingsToCarryDetails[i].thingsToCarryRow.trim() === '' || thingsToCarryDetails[i].thingsToCarryRow === null){
            showModal("Please enter a valid details in Things to carry row");
            return false;
        }
    }

    return true;
}

function validateEditTrek(trekName, totalSpots, numberOfDays, startDate, endDate, trekLocation, trekPrice, expDate, pickUpLocation, pickUpGmapLocation, trekDescription, difficultyLevel, trekLength, altitude, minAge, bookDetails, notIncludedDetails, thingsToCarryDetails,showModal){
    if(trekName.trim() === '' || trekName === null){
        showModal("Please enter a valid Trek Name");
        return false;
    }
    if(totalSpots === '' || totalSpots === null || totalSpots <= 0){
        showModal("Please enter a valid maximum trekkers");
        return false;
    }
    if(numberOfDays === '' || numberOfDays === null || numberOfDays <= 0){
        showModal("Please enter a valid number of days");
        return false;
    }
    if(trekLocation.trim() === '' || trekLocation === null ){
        showModal("Please enter a valid Trek Location");
        return false;
    }
    if(trekPrice === '' || trekPrice === null || trekPrice <= 0){
        showModal("Please enter a valid Trek Location Trek Price");
        return false;
    }
    if(pickUpLocation.trim() === '' || pickUpLocation === null ){
        showModal("Please enter a valid Pick Up Location");
        return false;
    }
    if(pickUpGmapLocation.trim() === '' || pickUpGmapLocation === null ){
        showModal("Please enter a valid pick up Location google map link");
        return false;
    }
    if(trekDescription.trim() === '' || trekDescription === null ){
        showModal("Please enter a valid Trek Description");
        return false;
    }
    if(difficultyLevel.trim() === '' || difficultyLevel === null ){
        showModal("Please enter a valid Difficulty Level");
        return false;
    }
    if(trekLength === '' || trekLength === null || trekLength <= 0){
        showModal("Please enter a valid Trek length");
        return false;
    }
    if(altitude === '' || altitude === null || altitude <= 0){
        showModal("Please enter a valid Trek length");
        return false;
    }
    if(minAge === '' || minAge === null || minAge <= 0){
        showModal("Please enter a valid Minimum Age");
        return false;
    }
    if(startDate === '' || startDate === null){
        showModal("Please enter a valid Start Date");
        return false;
    }
    if(endDate === '' || endDate === null){
        showModal("Please enter a valid End Date");
        return false;
    }
    if(expDate === '' || expDate === null){
        showModal("Please enter a valid End Date");
        return false;
    }
    if(new Date(startDate) > new Date(endDate)){
        showModal("Start Date is greater than end date");
        return false;
    }
    if(new Date(expDate) > new Date(startDate)){
        showModal("Expiry Date is greater than start date");
        return false;
    }
    if(new Date(expDate) > new Date(endDate)){
        showModal("Expiry Date is greater than end date");
        return false;
    }
    for(let i=0;i<bookDetails.length;i++){
        if(bookDetails[i].whatsNotIncluded === '' || bookDetails[i].whatsNotIncluded === null){
            showModal("Please enter a valid details in What's Included row");
            return false;
        }
    }
    for(let i=0;i<notIncludedDetails.length;i++){
        if(notIncludedDetails[i].whatsNotIncluded === '' || notIncludedDetails[i].whatsNotIncluded === null){
            showModal("Please enter a valid details in What's not Included row");
            return false;
        }
    }
    for(let i=0;i<thingsToCarryDetails.length;i++){
        if(thingsToCarryDetails[i].thingsToCarry === '' || thingsToCarryDetails[i].thingsToCarry === null){
            showModal("Please enter a valid details in Things to carry row");
            return false;
        }
    }


    return true;
}

module.exports = {
    validateBookingDetails, validateTrekDetails, validateEditTrek
};
